import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item", "previous"];

  initialize() {
    this.handleInputKeyUp = this.handleInputKeyUp.bind(this);
  }

  connect() {
    this.previousTarget.addEventListener("keyup", this.handleInputKeyUp);
  }

  disconnect() {
    this.previousTarget.removeEventListener("keyup", this.handleInputKeyUp);
  }

  handleKeyDown(e) {
    const selectedIndex = this.itemTargets.indexOf(document.activeElement);
    // down key
    if (e.which === 40) {
      if (selectedIndex === this.itemTargets.length - 1) {
        return false;
      }

      if (selectedIndex >= 0) {
        document.activeElement.setAttribute("tabindex", -1);
        this.itemTargets[selectedIndex + 1].tabindex = 0;
        this.itemTargets[selectedIndex + 1].setAttribute("tabindex", 0);
        this.itemTargets[selectedIndex + 1].focus();
      }
    }

    // up key
    if (e.which === 38) {
      if (selectedIndex === 0) {
        if (this.hasPreviousTarget) {
          this.previousTarget.focus();
        }
        return false;
      }

      if (selectedIndex >= 1) {
        document.activeElement.setAttribute("tabindex", -1);
        this.itemTargets[selectedIndex - 1].setAttribute("tabindex", 0);
        this.itemTargets[selectedIndex - 1].focus();
      }
    }
  }

  handleInputKeyUp(e) {
    // down key
    if (e.which === 40) {
      this.itemTargets.find((item) => item.tabIndex === 0)?.focus();
    }
  }
}
